module.exports = __webpack_public_path__ + "img/个性化营销.1d6739d1.png";